import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography,
  Checkbox
} from '@mui/material'
import { assignStudent } from '../../store/cartSlice'
import useMediaQuery from '@mui/material/useMediaQuery'
import CloseIcon from '@mui/icons-material/Close'
import StudentForm from '../studentForm'
import ModelHandler from '../../models/modelHandler'
import generateEmail from '../../utils/generateFakeEmail'
import { createUser } from '../../api/userApi'
import { addStudent } from '../../store/parentSlice'
import ParentAPI from '../../api/parentApi'
import ReactGA from 'react-ga4'
import ReactPixel from 'react-facebook-pixel'
import { setStudents } from '../../store/parentSlice'
import AlternatePaymentToolTip from '../alternatePaymentToolTip'
import CartCard from './cartCard'

export default function CartPanel({
  view,
  cartInv,
  discount,
  errors,
  useAlternate,
  handleChange,
  paymentType,
  handleDisable,
  user,
  purchaseByAdmin,
  termsCheck,
  handleTermsCheck,
  termsError,
  handleErrors,
  setErrors,
  mobile,
  couponApplied
}) {
  const dispatch = useDispatch()
  let students = useSelector((state) => state.parent.students)

  const [childList, setChildList] = useState([])

  useEffect(() => {
    let mounted = true
    async function handleAsync() {
      let resp = await ParentAPI.getParentStudents({
        params: { parentID: user._id }
      })
      if (resp.success) {
        dispatch(setStudents(resp.data))
        let tmpArr = [...resp.data]
        if (mounted) {
          setChildList(tmpArr)
        }
      } else {
        alert(resp)
      }
    }
    //check if user is logged in/selected
    if (user._id) {
      if (
        user.children.length > 0 && //user.children is list of studentIDs
        students.length === 0 //students is list of student objects
      ) {
        
        handleAsync()
      } else {
        let tmpArr = [...students]
        if (mounted) {
          setChildList(tmpArr)
        }
      }
    }
    ReactGA.send({ hitType: 'pageview', page: '/cart', title: 'Cart' })
    ReactPixel.pageView()
    return () => (mounted = false)
  }, [])

  useEffect(() => {
    if (childList.length === 1) {
      setChildList((prevState) => [...prevState, ...students])
    }
  }, [students])

  useEffect(() => {
    //Clears error warnings when a user fixes them
    let mounted = true
    if (mounted && Object.keys(errors).length > 0) {
      let errors = handleErrors()
      setErrors(errors)
    }
    return () => (mounted = false)
  }, [cartInv])

  //StudentForm logic
  const [showStudentForm, setShowStudentForm] = useState(false)
  const [newChild, setNewChild] = useState({})
  const [studentErr, setStudentErr] = useState([])
  const [currentProduct, setCurrentProduct] = useState(null)

  const handleSelectStudent = (student, product) => {
    if (student === 'create') {
      setShowStudentForm(true)
      setCurrentProduct(product)
    } else {
      dispatch(assignStudent({ student, product }))
    }
  }
  const handleNewUser = (type, value) => {
    setNewChild((prevState) => ({
      ...prevState,
      [type]: value
    }))
  }

  const handleNext = async () => {
    var tmp = newChild
    tmp.parentID = user._id
    tmp.addrCheck = true // temp work around for not adding extra fields
    if (tmp.addrCheck === undefined || tmp.addrCheck === true) {
      tmp.address = user.info.address
    }
    let err = ModelHandler.checkStudentData(tmp, true)
    if (err.length === 0) {
      if (!('email' in tmp) || tmp.email === '') {
        tmp.email = generateEmail(tmp)
      }
      let data = ModelHandler.student(tmp)
      let resp = await createUser(data)

      setNewChild(resp)
      setShowStudentForm(false)
      dispatch(addStudent(resp.data))
      dispatch(
        assignStudent({ student: resp.data._id, product: currentProduct })
      )
      setChildList((prevState) => [...prevState, resp.data])
    } else {
      // handle
      // setStudentErr(errors)
    }
  }

  const styles = {
    leftBox: {
      gridRow: '2 /3',
      gridColumn: mobile ? '1/3' : '1/2',
      padding: '16px'
    },
    termsBox: {
      display: 'flex'
    }
  }

  return (
    <>
      <Box id='left' sx={styles.leftBox}>
        {view === 0 ? (
          <>
            {cartInv.length === 0 ? (
              <Typography>Your Cart is Empty</Typography>
            ) : (
              cartInv.map((course, index) => {
                return (
                  <div style={{ margin: '10px' }} key={`${course.id}_${index}`}>
                    <CartCard
                      discount={discount}
                      children={childList}
                      workshop={course}
                      handleSelectStudent={handleSelectStudent}
                      errors={errors?.[course['cartID']]}
                      couponApplied={couponApplied}
                    />
                  </div>
                )
              })
            )}
          </>
        ) : (
          <Box>
            <Typography sx={{ fontWeight: 'bold', marginTop: '5px' }}>
              Pay with:
            </Typography>
            <FormControl
              sx={{
                '& .MuiFormControlLabel-root': { alignItems: 'flex-start', marginLeft: '0px' }
              }}
            >
              <RadioGroup
                aria-labelledby='payment-options-radio-group'
                name='payment-options-radio-group'
                onChange={(e) => handleChange(e.target.value)}
                defaultValue={useAlternate ? 'alternate_payment' : 'card'}
              >
                <FormControlLabel
                  disabled={handleDisable('card')}
                  value='card'
                  control={<Radio />}
                  label={
                    <>
                      <Typography textAlign='left' sx={{ marginTop: '8px' }}>
                        Credit Card
                      </Typography>
                    </>
                  }
                  checked={paymentType === 'card'}
                />
                {/* <FormControlLabel
                  disabled={handleDisable('us_bank_account')}
                  value='us_bank_account'
                  control={<Radio />}
                  label={
                    <>
                      <Typography textAlign='left' sx={{ marginTop: '8px' }}>
                        Direct Debit (ACH)
                      </Typography>
                      {handleDisable('us_bank_account') ? (
                        <Typography textAlign='left' sx={{ fontSize: '12px' }}>
                          Direct Debit (ACH) is not available for camps that
                          start within 2 days.
                        </Typography>
                      ) : (
                        <></>
                      )}
                    </>
                  }
                  checked={paymentType === 'us_bank_account'}
                /> */}
                {user.creditAuthorized || purchaseByAdmin ? (
                  <FormControlLabel
                    disabled={handleDisable('alternate_payment')}
                    value='alternate_payment'
                    control={<Radio />}
                    label={
                      <>
                        <Typography display='inline' sx={{ marginTop: '8px' }}>
                          Alternate Payment
                        </Typography>
                        <AlternatePaymentToolTip />
                      </>
                    }
                    checked={paymentType === 'alternate_payment'}
                  />
                ) : (
                  <></>
                )}
              </RadioGroup>
            </FormControl>
            <Typography sx={{ fontWeight: 'bold', marginTop: '5px' }}>
              Terms and Conditions
            </Typography>
            <Box sx={styles.termsBox}>
              <Checkbox
                checked={termsCheck}
                onChange={(e) => handleTermsCheck()}
                sx={styles.termsCheckbox}
              />
              <Typography sx={{ fontSize: '11px', textAlign: 'left', alignSelf: 'center' }}>
                By checking this box, you confirm that you have read and agree
                to our{' '}
                <b>
                  <a href='/terms#terms-and-conditions' target='_blank'>
                    terms and conditions
                  </a>
                </b>
                , as well as the
                <b>
                  {' '}
                  <a href='/terms#waiver' target='_blank'>
                    liability waiver
                  </a>
                </b>
                .
              </Typography>
            </Box>
            {termsError ? (
              <Typography sx={{ fontSize: '11px', color: 'red' }}>
                Please check above to agree to Terms & Conditions and liability
                waiver.
              </Typography>
            ) : (
              <></>
            )}
          </Box>
        )}
      </Box>
      {showStudentForm ? (
        <StudentForm
          data={newChild}
          errors={studentErr}
          handleChange={handleNewUser}
          handleNext={handleNext}
          handleClose={() => {
            setShowStudentForm(false)
          }}
        />
      ) : (
        <React.Fragment />
      )}
    </>
  )
}
